import { Clickable } from 'foundations-components/transitional/components/Clickable';
import { Heading } from 'foundations-components/transitional/components/Heading';
import { Box } from 'foundations-components/transitional/components/Box';
import { ButtonWrapper } from 'foundations-components/transitional/components/ButtonWrapper';
import { Lightbox } from 'foundations-components/transitional/components/Lightbox';
import { Section } from 'foundations-components/transitional/components/Section';
import { BreakString } from 'foundations-components/transitional/components/BreakString';
import { Flex } from 'foundations-components/components/Flex';
import { Image } from 'foundations-components/transitional/components/Image';
import { useResponsiveProps } from 'marketplace-ui-common/hooks/useResponsiveProps';
import * as ScreenSizes from 'marketplace-ui-common/layout/constants/ScreenSizes';
import { Fragment, useCallback, useEffect, useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function AssetFeatures({
  features,
  onTrackInteraction
}) {
  const [lightboxFeatureIndex, setLightboxFeatureIndex] = useState(null);
  const {
    featureImageWidth,
    isMobileView
  } = useResponsiveProps({
    featureImageWidth: {
      xs: '100%',
      lg: 350
    },
    isMobileView: {
      [ScreenSizes.XS]: true,
      [ScreenSizes.LG]: false
    }
  });
  const trackInteraction = useCallback((action, eventProperties = {}) => {
    onTrackInteraction(action, Object.assign({}, eventProperties, {
      section: 'features'
    }));
  }, [onTrackInteraction]);
  useEffect(() => {
    if (lightboxFeatureIndex != null) {
      const closeButton = document.querySelector('[role="button"][data-action="close"]');
      if (closeButton) {
        closeButton.focus();
      }
    }
  }, [lightboxFeatureIndex]);
  const renderLightboxFeature = useCallback(() => {
    if (lightboxFeatureIndex === null) {
      return null;
    }
    const {
      headline,
      imageUrl,
      text
    } = features[lightboxFeatureIndex];
    return /*#__PURE__*/_jsx(Lightbox, {
      imageAlt: headline,
      imageSrc: imageUrl,
      onClose: () => {
        setLightboxFeatureIndex(null);
        trackInteraction('close feature image lightbox');
      },
      children: /*#__PURE__*/_jsx(ButtonWrapper, {
        children: /*#__PURE__*/_jsx("span", {
          children: text
        })
      })
    });
  }, [features, lightboxFeatureIndex, trackInteraction]);
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [features.map((feature, index) => {
      const {
        headline,
        imageUrl,
        text
      } = feature;
      const alternate = !(index % 2);
      const flexDirection = isMobileView ? 'column' : alternate ? 'row-reverse' : 'row';
      const renderedFeatureImage = /*#__PURE__*/_jsx(Clickable, {
        onClick: () => {
          setLightboxFeatureIndex(index);
          trackInteraction('click feature image', {
            itemIndex: index
          });
        },
        children: /*#__PURE__*/_jsx(Image, {
          alt: headline,
          src: imageUrl,
          inlineSize: `${featureImageWidth}px`
        })
      });
      return /*#__PURE__*/_jsx(Section, {
        marginBlockEnd: "1000",
        children: /*#__PURE__*/_jsxs(Flex, {
          flexDirection: flexDirection,
          alignItems: isMobileView ? 'start' : 'center',
          gap: isMobileView ? '400' : '1200',
          children: [/*#__PURE__*/_jsxs(Box, {
            grow: 1,
            shrink: 1,
            children: [/*#__PURE__*/_jsx(Heading, {
              tagName: "h4",
              "aria-level": 5,
              children: /*#__PURE__*/_jsx(BreakString, {
                children: headline
              })
            }), /*#__PURE__*/_jsx(BreakString, {
              children: text
            })]
          }), /*#__PURE__*/_jsx(Box, {
            basis: featureImageWidth,
            grow: 0,
            shrink: 0,
            children: renderedFeatureImage
          })]
        })
      }, `feature-section-${index}`);
    }), renderLightboxFeature()]
  });
}